import { useEffect } from "react";

import { navBarEnabled } from "@/store";

export default function useNavBar() {
  useEffect(() => {
    navBarEnabled(true);

    return () => {
      navBarEnabled(false);
    };
  }, []);

  return null;
}
